module.exports = __webpack_public_path__ + "media/assets/images/car_blacknumber_reviewimage-76e31283b2285b1c2e05979c1309933f.png";